export default {
    searchBy: 'ค้นหาด้วยชื่อวันทำงานพิเศษ',
    search: 'ค้นหา',
    addSpecialWorkday: 'เพิ่มวันทำงานพิเศษ',
    specialWorkdayName: 'ชื่อ',
    workDay: 'วันที่ทำงาน',
    dateCreate: 'วันที่สร้าง',
    startEndTime: 'เวลาเริ่ม - เวลาสิ้นสุด',
    description: 'คำอธิบาย',
    forGroup: 'กลุ่มที่เลือก',
    deleteGroup: 'ลบวันทำงานพิเศษ',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'วันทำงานพิเศษถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบวันทำงานพิเศษ "$Name" ?'
}
